// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconHeart = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M7.5 3c1.86 0 3.505.923 4.5 2.337A5.5 5.5 0 0122 8.5c0 3.498-2.39 6.624-4.546 8.763a30 30 0 01-3.025 2.603c-.533.4-1.08.781-1.64 1.134h-1.561s-1.274-.81-1.638-1.07a27 27 0 01-3.036-2.525C4.38 15.295 2 12.172 2 8.5A5.5 5.5 0 017.5 3M4 8.5a3.5 3.5 0 117 0V9h2v-.5a3.5 3.5 0 117 0c0 2.642-1.86 5.266-3.954 7.342A27.6 27.6 0 0112.2 19h-.418a25 25 0 01-3.837-3.03C5.87 13.955 4 11.328 4 8.5"
    />
  );
export default SvgIconHeart;
